import { useDispatch, useSelector } from '@bonanza-social/toolkit/state';
import { useEffect, useMemo } from 'react';
import {
  fetchShopSales,
  selectSales,
  selectSalesDataState,
} from '../state/sales/sales.slice';

const useShopSales = () => {
  const dispatch = useDispatch();
  const shopSales = useSelector(selectSales);
  const shopSalesDataState = useSelector(selectSalesDataState);

  const returnObj = useMemo(
    () => ({
      shopSales,
      shopSalesDataState,
    }),
    [shopSales, shopSalesDataState],
  );

  useEffect(() => {
    dispatch(fetchShopSales());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return returnObj;
};

export default useShopSales;
